import data from '../data'

export const selectCyNodes = (cyRef, selection) => {
  const cy = cyRef.current;
  cy.elements().removeClass('dimmed');
  
    if (selection) {
      const { selectedNodes} = selection
      const cyNodes = cy.nodes().filter(n => selectedNodes.includes(n.id()))
      const connectedEdges = cyNodes.connectedEdges().filter(e => cyNodes.includes(e.source()) && cyNodes.includes(e.target()))

    // Atenuar elementos no relacionados
   cy.elements()
      .not(cyNodes)
      .not(connectedEdges)
 //     .not(connectedNodes)
      .addClass('dimmed')
    }
  }

const isConnected = (nodeId, edge) => {
  return edge.data.source === nodeId || edge.data.target === nodeId
}

export const selectEdges = (selectedNodeId) => {
  const { elements: { edges: allEdges }} = data
  return allEdges.filter(edge => isConnected(selectedNodeId, edge))
}

export const selectNodes = (edges) => {
  const { elements: { nodes: allNodes }} = data 
  return allNodes.filter(node => edges.some(edge => isConnected(node.data.id, edge))).map(node => node.data.id)
}

export const connectedNodes = (nodeId) => {
  // buscar las conexiones de nodeid
  const connectedEdges = selectEdges(nodeId)

  // buscar los nodos conectados al nodo elegido nodeId
  return selectNodes(connectedEdges) 
}